export enum VacancyApplicationStatuses {
  NEW = 1,
  ARCHIVED = 2,
  APPLIED = 3,
  IN_PROGRESS = 4,
}
